export const colorStyles = {
  primary: {
    solid: "#7367f0",
    light: "rgba(115, 103, 240, 0.12)",
  },
  secondary: {
    solid: "#82868b",
    light: "rgba(130, 134, 139, 0.12)",
  },
  success: {
    solid: "#28c76f",
    light: "rgba(40, 199, 111, 0.12)",
  },
  info: {
    solid: "#00cfe8",
    light: "rgba(0, 207, 232, 0.12)",
  },
  danger: {
    solid: "#ea5455",
    light: "rgba(234, 84, 85, 0.12)",
  },
  warning: {
    solid: "#ff9f43",
    light: "rgba(255, 159, 67, 0.12)",
  },
  dark: {
    solid: "#4b4b4b",
    light: "rgba(75, 75, 75, 0.12)",
  },
};
